/**
 * Example:
 *
 * export default [
 *   new Experiment({
 *     experimentName: constants.EXAMPLE_EXPERIMENT_NAME,
 *     jira: 'HPWEB-0000'
 *   })
 * ]
 */

/** Uncomment these imports when running experiments */
import { Experiment } from 'app/shared/models/Experiment';
import constants from 'app/shared/constants/ExperimentConstants';

export default [
  new Experiment({
    experimentName: constants.HOTPADS_WEB_HDP_AA_TEST,
    jira: 'HP-6197',
  }),
  new Experiment({
    experimentName: constants.HOTPADS_WEB_DOT_MAP_TEST,
    jira: 'HP-6241',
  }),
  new Experiment({
    experimentName: constants.HOTPADS_WEB_APPLY_INSTANTLY,
    jira: 'HPWEB-6371',
  }),
  new Experiment({
    experimentName: constants.HOTPADS_WEB_NEW_UNITS,
    jira: 'HP-6419',
  }),
  new Experiment({
    experimentName: constants.HOTPADS_WEB_PRICE_DROPS,
    jira: 'HPWEB-6547',
  }),
  new Experiment({
    experimentName: constants.HOTPADS_WEB_APARTMENT_ONLY_LINKS,
    jira: 'HPWEB-6587',
  }),
  new Experiment({
    experimentName: constants.HOTPADS_WEB_CTA_COPY_TEST,
    jira: 'HP-6450',
  }),
  // HPWEB-6595 A/B TEST - Delete when experiment ends
  new Experiment({
    experimentName: constants.HOTPADS_WEB_APARTMENT_CONDO_SRP,
    jira: 'HPWEB-6595',
  }),
];
